<div class="d-sm-flex docSection" style="justify-content: center">
  <span class="md-form m-3">
    <select
      class="md-form m-0 form-control browser-default"
      id="docType"
      [(ngModel)]="selectedDocType"
      placeholder="Docs"
      (change)="onSelectionChange()"
    >
      <option *ngFor="let option of docTypeOptions" [ngValue]="option.value">
        {{ option.label }}
      </option>
    </select>
    <label for="docType" class="active">Document type</label>
  </span>
  <ng-container *ngIf="!isInProgress">
    <ng-container *ngIf="canSendDocDirect()">
      <button mdbBtn color="trakly-action" class="md-form m-3 relative waves-light btn-sm btn" (click)="sendDoc()">Send Document</button>
    </ng-container>
    <ng-container *ngIf="canSendLoanAgreementDoc()">
      <button mdbBtn color="trakly-action" class="md-form m-3 relative waves-light btn-sm btn" (click)="showLoanAgreementForm()">
        Create Loan Agreement
      </button>
    </ng-container>
  </ng-container>

  <app-loading [busy]="sendingDoc"></app-loading>
</div>

<ng-container *ngIf="isInProgress">
  <div class="d-flex justify-content-center">
    <div class="col-12 col-md-6">
      <div class="card alert alert-warning text-center">
        <div class="card-body p-0">
          <div>{{ selectedDocTypeName }} document is in progress</div>
          <div>cancel to send another</div>
        </div>
      </div>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="docs.length === 0">
  <div class="md-form">
    <app-loading [busy]="loadingGrid" [busyText]="'Loading data...'"></app-loading>
    <div class="card alert alert-warning mb-4 text-center" *ngIf="!loadingGrid">
      <div class="card-body">No documents sent to this user yet</div>
    </div>
  </div>
</ng-container>

<div class="table-responsive" *ngIf="docs.length > 0 && !loadingGrid">
  <table mdbTable class="table table-responsive w-100 d-block d-md-table" hover="true" small="true" responsive="true">
    <thead>
      <tr>
        <th scope="col">Doc Type</th>
        <th scope="col">Date Sent</th>
        <th scope="col">Status</th>
      </tr>
    </thead>
    <tbody>
      <ng-container *ngFor="let doc of docs">
        <tr
          mdbTableCol
          [ngClass]="{
            'update-success': doc.recentlyUpdated
          }"
        >
          <td class="align-middle">{{ doc.type }}</td>
          <td class="align-middle">{{ doc.dateSent | date: "dd MMM yyyy 'at:' HH:mm" }}</td>
          <td class="align-middle">
            <ng-container *ngIf="!doc.busy">
              <div style="display: inline-block">
                <span mdbTooltip="{{ doc.message }}">
                  <span class="badge align-middle" [ngClass]="getStatusBadge(doc.status)">{{ doc.status }}</span>
                </span>

                <ng-container *ngIf="doc.status === 'InProgress'">
                  <span mdbTooltip="Cancel">
                    <span class="clickable fas fa-ban actionIcon align-middle" (click)="cancelDoc(doc)"></span>
                  </span>
                </ng-container>
                <ng-container *ngIf="canDownloadDoc(doc)">
                  <span mdbTooltip="Download">
                    <span class="clickable fas fa-circle-arrow-down actionIcon align-middle" (click)="downloadDoc(doc)"></span>
                  </span>
                </ng-container>
              </div>
            </ng-container>
            <ng-container *ngIf="doc.busy">
              <div style="display: inline-block">
                <app-loading [busy]="doc.busy" [busyText]="busyText"></app-loading>
              </div>
            </ng-container>
          </td>
        </tr>
      </ng-container>
    </tbody>
  </table>
</div>

<error-component [error]="errorResponse" [(showModal)]="showError"></error-component>

<app-create-document
  [documentType]="1"
  [lenderFullName]="spouseFullName"
  [borrowerFullName]="fullName"
  [userIdentifiers]="userIdentifiers"
  [(showModal)]="showLoanAgreement"
  (modalClosed)="handleModalClosed()"
  (errorOccurred)="handleError($event)"
  (documentAdded)="handleRecordUpdated($event)"
></app-create-document>
